import { bl_ppl_ap_validation_test_hdr_RowClass } from '../../../dbschema/bl_ppl_ap_validation_test_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class PeppolAPTestbedValidationTestHdrContainerModel extends BaseContainerModel {
    bl_ppl_ap_validation_test_hdr: bl_ppl_ap_validation_test_hdr_RowClass = new bl_ppl_ap_validation_test_hdr_RowClass();
}